import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"

import {QueryCustomerFileArgs} from "@irati/types"
import customerFile, {customerFileKey} from "./queries/customerFile"

class CustomerFile extends PBService {
  customerFile(variables: QueryCustomerFileArgs, options: QueryOptions = {}) {
    return client
      .query({
        ...options,
        query: customerFile,
        variables,
        context: {reqEUinstance: true},
        fetchPolicy: "no-cache"
      })
      .then(({data}) => data[customerFileKey])
  }
}

const customerFileService = new CustomerFile({errorHandlers: []})

export default customerFileService
